import { BaseService, endpoints, http } from '../../services/base';
import { ResponsibilityDto, ResponsibilityFilter } from '../account/dto/Responsibility';

export class ResponsibilityService extends BaseService<ResponsibilityDto> {
  constructor() {
    super(endpoints.responsibilities.default);
  }

  public async findAll(params?: ResponsibilityFilter): Promise<ResponsibilityDto[]> {
    const { data: res } = await http.get(this.url, { params });
    return res;
  }

  public async postName(name: string): Promise<ResponsibilityDto> {
    const { data } = await http.post(this.url, { name });
    return data;
  }

  public async deleteById(id: string): Promise<ResponsibilityDto> {
    const { data } = await http.delete(this.url + `/${id}`);
    return data;
  }

  public async countAdmin(id: string): Promise<{ count: string }> {
    const { data: res } = await http.get(this.url + `/${id}/count-users`);
    return res;
  }
}
